import { SupportedCurrencyEnum } from '@goparrot/common';
import React from 'react';
import { FormattedNumber } from 'react-intl';

export const getFormattedNumber: (value: number) => React.ReactElement = (value: number) => (
  <FormattedNumber value={value} style="currency" currency={SupportedCurrencyEnum.USD} />
);
